// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".discard[data-v-0baabfe3]{color:#5c6873;float:right;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
